import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5055/api';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ts_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('ts_token');
      localStorage.removeItem('ts_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const login = (username, password) =>
  api.post('/auth/login', { username, password });

export const verifyToken = () => api.get('/auth/verify');

export const getHealth = () => api.get('/health');
export const getStats = () => api.get('/stats');
export const syncData = () => api.post('/sync');
export const getJobs = () => api.get('/jobs');
export const getJob = (ref) => api.get(`/jobs/${ref}`);
export const getJobCandidates = (ref) => api.get(`/jobs/${ref}/candidates`);
export const computeJobMatching = (ref) => api.post(`/matching/job/${ref}`);
export const computeAllMatchings = () => api.post('/matching/all');

export default api;
